export default __webpack_public_path__ + "static/media/all-cases-icon.b74f428c.svg";